import styled from 'styled-components';
import { ROUTES } from '../../routing';
import ContentCard, {
  CardIcon,
  CardLabelUppercase,
  CardHeader,
  CardPSmall,
  TopSection,
  BottomSection,
} from '../ContentCard';
import { TeamsContentModule } from '../../api/teams';
import { useParams } from 'react-router-dom';

const CardRow = styled.div`
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;
  flex-direction: row;
  display: flex;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;
export const Badge = styled(CardLabelUppercase)`
  background-color: ${({ theme }) => theme.colors.bgActive};
  padding: 4px 8px 4px 8px;
  border-radius: 8px;
  margin: 0;
`;

export function ActiveTrackCard({ module }: { module: TeamsContentModule }) {
  const { companySlug } = useParams<{ companySlug: string | undefined }>();
  function getButtonsProps(module: TeamsContentModule) {
    const nextMissionSlug = module.firstUnattemptedActivity?.missionSlug;
    const nextActivitySlug = module.firstUnattemptedActivity?.activitySlug;

    return [
      ...(nextActivitySlug && nextMissionSlug
        ? [
            {
              label: module.hasSubmission ? 'Continue' : 'Start',
              href: ROUTES.TEAMS.ACTIVITY.getPath({
                teamSlug: companySlug,
                trackSlug: module.trackSlug ?? '',
                missionSlug: nextMissionSlug,
                activitySlug: nextActivitySlug,
              }),
            },
          ]
        : []),
      {
        label: 'Dashboard',
        href: ROUTES.TEAMS.MODULE_DASHBOARD.getPath({
          teamSlug: companySlug,
          moduleSlug: module.content.slug,
          trackSlug: module.trackSlug ?? '',
        }),
      },
    ];
  }

  return (
    <TrackCard
      imageUrl={module.content.imageUrl}
      topic={module.content.topic}
      content={module.content.title}
      description={module.content.description ?? ''}
      lessonsCount={module.lessonsCount}
      buttonProps={getButtonsProps(module)}
    />
  );
}

const TrackCard = ({
  imageUrl,
  topic,
  content,
  lessonsCount,
  buttonProps,
  description,
}: {
  imageUrl: string;
  topic: string;
  content: string;
  lessonsCount: number;
  description: string;
  buttonProps:
    | {
        label: string;
        isDisabled: boolean;
        onClick: () => void;
      }[]
    | {
        label: string;
        href: string;
      }[];
}) => {
  return (
    <ContentCard buttonProps={buttonProps}>
      <TopSection>
        <Row>
          <CardIcon url={imageUrl} title={`${topic} Track`} />
          <Badge>TEAMS</Badge>
        </Row>
        <CardLabelUppercase>module</CardLabelUppercase>
        <CardHeader>{content}</CardHeader>
        <CardPSmall>{description}</CardPSmall>
      </TopSection>
      <BottomSection>
        <CardRow>
          <CardPSmall>{lessonsCount} missions</CardPSmall>
        </CardRow>
      </BottomSection>
    </ContentCard>
  );
};
